import React from 'react';
import { Spinner } from '@/Components/shadcn';

function TabLoadingSpinner(): React.JSX.Element {
    return (
        <div className="flex h-128 items-center justify-center">
            <Spinner className="text-primary size-8" />
        </div>
    );
}

export default TabLoadingSpinner;
